import {
	ART_COLORS,
	ATTENTION_EMOJIS,
	type AttentionLevel,
	type BookingArt,
	type BookingStatus,
	STATUS_EMOJIS,
} from "@booking-hub/shared";

// ============================================================
// UI Helpers
// ============================================================

export function statusColor(status: BookingStatus): string {
	const map: Record<BookingStatus, string> = {
		Anfrage: "bg-blue-100 text-blue-800",
		Angebot: "bg-amber-100 text-amber-800",
		Bestätigt: "bg-emerald-100 text-emerald-800",
		"Rechnung offen": "bg-orange-100 text-orange-800",
		Bezahlt: "bg-green-100 text-green-800",
		Abgeschlossen: "bg-stone-100 text-stone-600",
		Storniert: "bg-red-100 text-red-700",
		Verschoben: "bg-purple-100 text-purple-800",
	};
	return map[status] ?? "bg-stone-100 text-stone-600";
}

export function statusEmoji(status: BookingStatus): string {
	return STATUS_EMOJIS[status] ?? "📋";
}

export function artDotColor(art: BookingArt): string {
	return ART_COLORS[art] ?? "#999";
}

export function attentionBadge(level: AttentionLevel): string {
	const map: Record<AttentionLevel, string> = {
		critical: "bg-red-100 text-red-800",
		warning: "bg-amber-100 text-amber-800",
		info: "bg-blue-100 text-blue-800",
		low: "bg-stone-100 text-stone-600",
	};
	return map[level] ?? "bg-stone-100 text-stone-600";
}

export function attentionEmoji(level: AttentionLevel): string {
	return ATTENTION_EMOJIS[level] ?? "🔵";
}

export function formatDate(iso: string | null | undefined): string {
	if (!iso) return "—";
	return new Date(iso).toLocaleDateString("de-DE", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	});
}

export function formatCurrency(amount: number | null | undefined): string {
	if (amount == null) return "—";
	return new Intl.NumberFormat("de-DE", {
		style: "currency",
		currency: "EUR",
	}).format(amount);
}

export function cn(...classes: (string | false | null | undefined)[]): string {
	return classes.filter(Boolean).join(" ");
}

export function relativeTime(iso: string): string {
	const diff = Date.now() - new Date(iso).getTime();
	const mins = Math.floor(diff / 60000);
	if (mins < 1) return "gerade eben";
	if (mins < 60) return `vor ${mins} Min`;
	const hours = Math.floor(mins / 60);
	if (hours < 24) return `vor ${hours} Std`;
	const days = Math.floor(hours / 24);
	if (days === 1) return "vor 1 Tag";
	if (days < 7) return `vor ${days} Tagen`;
	return formatDate(iso);
}

/** Decode HTML entities from Gmail snippets (e.g. &lt; → <) */
export function decodeHtmlEntities(text: string): string {
	const el = document.createElement("textarea");
	el.innerHTML = text;
	return el.value;
}
